import {Dispatch } from "redux";
import {ProfileAction as Action} from "src/stores/actions/profileActions";
import {ProfileActionType as ActionType} from "src/stores/action-types/profileActionType";

export const setProfile = (profileId: number | undefined) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_PROFILE,
            payload: profileId
        });
    }
}

export const reloadProfile = (reload = true) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.RELOAD_PROFILE,
            payload: reload
        });
    }
}